var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLetterTransparent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6888 15.0784C10.5721 15.1952 10.4055 15.2475 10.2429 15.2183C10.0803 15.1892 9.94229 15.0823 9.87344 14.932L7.38465 9.50758C7.30995 9.34483 7.32716 9.1548 7.42973 9.00811L9.27611 6.36922L6.64962 8.22459C6.57727 8.27576 6.49285 8.30702 6.40457 8.31509C6.31641 8.32317 6.22766 8.30795 6.14723 8.27072L0.702377 5.76119C0.579207 5.70441 0.48402 5.60044 0.438476 5.47259C0.392815 5.34485 0.400542 5.20412 0.460019 5.08213C0.51938 4.96013 0.625454 4.86717 0.754127 4.82432L14.8818 0.115596C15.0007 0.076023 15.1302 0.0822274 15.245 0.133041C15.3596 0.183854 15.4513 0.275529 15.5021 0.39015C15.5529 0.504889 15.5591 0.634381 15.5195 0.75333L10.8108 14.8813C10.7861 14.9556 10.7444 15.0232 10.6889 15.0785L10.6888 15.0784Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterTransparent);
export default __webpack_public_path__ + "static/media/LetterTransparent.a0c74a7d881b600c7bf574fe57c3f506.svg";
export { ForwardRef as ReactComponent };